import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Creation from './creation';
import Success from './success';

export default function CreateListing({ deal, onClose, onSave }) {
  const [listing, setListing] = useState();

  function handleCreate(listing) {
    setListing(listing);
    onSave(listing);
  }

  if (listing) {
    return <Success listing={listing} onClose={onClose} />;
  } else {
    return <Creation deal={deal} onClose={onClose} onCreate={handleCreate} />;
  }
}

CreateListing.propTypes = {
  deal: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
